module.exports = __webpack_public_path__ + "static/media/locationInput.6209f670.svg";